import {
  GET_PT_LIST_BOARD,
  GET_PT_LIST_EMPLOYEE,
  GET_PT_LIST_EMPLOYEE_MANAGMENT,
  GET_PT_LIST_JOB_LEVEL,
  GET_PT_LIST_STRUCTURE,
} from '_revamp/redux/action/admin/employee/admin';

const initialState = {
  listEmployee: [],
  listBoard: [],
  listEmployeeManagement: [],
  listStructure: [],
  listJobLevel: [],
};

const manageEmployee = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PT_LIST_EMPLOYEE: {
      return {
        ...state,
        listEmployee: payload,
      };
    }
    case GET_PT_LIST_BOARD: {
      return {
        ...state,
        listBoard: payload,
      };
    }
    case GET_PT_LIST_EMPLOYEE_MANAGMENT: {
      return {
        ...state,
        listEmployeeManagement: payload.rows,
      };
    }
    case GET_PT_LIST_STRUCTURE: {
      return {
        ...state,
        listStructure: payload.rows,
      };
    }
    case GET_PT_LIST_JOB_LEVEL: {
      return {
        ...state,
        listJobLevel: payload.rows,
      };
    }
    default:
      return state;
  }
};

export default manageEmployee;
